import { render, staticRenderFns } from "./Pods.vue?vue&type=template&id=606e1304&"
import script from "./Pods.vue?vue&type=script&lang=js&"
export * from "./Pods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports